import http from "@/apps/shared/baseService/config";

const base = {
  rota: "evaluation",
  nome: "Avaliação"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_evaluations: ({ commit, dispatch, getters }) => {
      if (localStorage.getItem("evaluations")) {
        commit("set_evaluations", JSON.parse(localStorage.getItem("evaluations")));
      } else {
        dispatch("enableLoading");
      }
      service
        .listar(getters.get_evaluations_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("evaluations", JSON.stringify(res.data));
          commit("set_evaluations", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_evaluation: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({ ...getters.get_evaluation, imagens: getters.getLinks })
        .then(res => {
          dispatch("disableLoading");
          commit("set_evaluation", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_evaluations");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_evaluation: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_evaluation, imagens: getters.getLinks })
        .then(() => {
          dispatch("disableLoading");
          commit("set_evaluation", {});
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_evaluations");
          commit("set_modal_view_evaluation", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_evaluation: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_evaluations");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_evaluation: ({ commit }, payload) => {
      if (payload) {
        commit("set_evaluation", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_evaluation", true);
    },
    fecha_modal_view_evaluation: ({ commit }) => {
      commit("set_evaluation", {});
      commit("setLinks", []);
      commit("set_modal_view_evaluation", false);
    }
  },
  state: {
    evaluation: {},
    evaluations: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    evaluations_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_evaluation: false
  },
  mutations: {
    set_evaluation: (state, payload) => (state.evaluation = payload),
    set_evaluations: (state, payload) => (state.evaluations = payload),
    set_modal_view_evaluation: (state, payload) =>
      (state.modal_view_evaluation = payload)
  },
  getters: {
    get_evaluation: state => state.evaluation,
    get_evaluations: state => state.evaluations,
    get_modal_view_evaluation: state => state.modal_view_evaluation,
    get_evaluations_filtros: state => state.evaluations_filtros
  }
};

const routes = [
  {
    path: `/avaliacoes`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  },
  {
    path: `/avaliacao`,
    component: () => import("./views/NewEvaluation.vue"),
    name: base.nome
  },
];

export default {
  service,
  module,
  routes
};
